import PropTypes from 'prop-types';
import Text from '@/components/Text';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

export default function CardText({
  children,
}) {
  return (
    <Text muted>
      {children}
    </Text>
  );
}

CardText.defaultProps = defaultProps;
CardText.propTypes = propTypes;
